
































































































import {Component, Watch} from "vue-property-decorator";
import HeaderLayout from "@/layouts/nested/HeaderLayout.vue";
import Base from "@/views/Base";
import WHeaderBtn from "@/components/WHeaderBtn.vue";
import ListWithHeaderLayout from "@/layouts/nested/ListWithHeaderLayout.vue";
import {PresentationTableItem} from "@/models/Presentation";
import PresentationService from "@/service/PresentationService";
import WListOptions from "@/components/listlayout/WListOptions.vue";
import PresentationCard from "@/views/presentation/components/PresentationCard.vue";
import {SelectOption} from "@/models/common";
import PresentationTable from "@/views/presentation/components/PresentationTable.vue";
import PresentationIndexPreview from '@/views/presentation/components/PresentationIndexPreview.vue';

@Component({
  components: {
    PresentationIndexPreview,
    PresentationTable, PresentationCard, WListOptions, ListWithHeaderLayout, WHeaderBtn, HeaderLayout}
})
export default class Presentation extends Base {
  items: PresentationTableItem[] = [];
  options = {
    mode: 'table',
    entryCount: 9999,
    searchTerm: '',
    currentPage: 1,
    totalRows: 0,
    sortBy: 'dateUpdated',
    sortDirection: 'DESC' as 'DESC' | 'ASC'
  };

  baseLoading = false;
  isSortDesc = this.options.sortDirection === 'DESC';
  allSelected = false;
  editIds: number[] = [];

  editOptions: SelectOption[] = [
    {value: 'action', text: this.$t('common.changeSelection') as string, disabled: true},
    {value: 'invert', text: this.$t('common.invertSelection') as string},
    {value: 'all', text: this.$t('common.selectAll') as string},
    {value: 'none', text: this.$t('common.deselectAll') as string}
  ]
  selectedEditOption: 'invert' | 'all' | 'none' | 'action' = 'action';

  mounted() {
    this.getPresentations();
  }

  get editMode(): boolean {
    return this.editIds.length > 0;
  }

  get isCards(): boolean {
    return this.options.mode === 'cards';
  }

  @Watch('options', {deep: true})
  onOptionsChanged(newOptions: any, oldOptions: any) {
    if (newOptions.sortBy === 'timeToLive') this.options.sortBy = 'dateUpdated';
    this.getPresentations();
    this.isSortDesc = this.options.sortDirection === 'DESC';
  }

  @Watch('isSortDesc')
  onSortDescChanged() {
    this.options.sortDirection = this.isSortDesc ? 'DESC' : 'ASC';
  }

  @Watch('editIds', {deep: true})
  onEditIdsChanged() {
    this.allSelected = this.editIds.length === this.items.length && this.items.length > 0;
  }

  getPresentations() {
    this.baseLoading = true;
    this.editIds = [];
    this.allSelected = false;
    PresentationService
      .getPresentations(
        this.options.currentPage - 1,
        this.options.entryCount,
        this.options.sortBy || 'dateUpdated',
        this.options.sortDirection,
        this.options.searchTerm
      )
      .then(res => {
        this.items = res.content
          ? res.content.map(PresentationService.presentationToTableItem)
          : [];
      })
      .catch(this.showNetworkError)
      .finally(() => this.baseLoading = false)
  }

  showPlayer(item: PresentationTableItem){
    if(item.elementCount > 0) {
      const preview = this.$refs['preview-player'] as any;
      preview.showPreview(item);
    }
  }

  editPresentation(item: PresentationTableItem) {
    if(!item.isGlobal || this.hasPermission('CUSTOMER_PRESENTATION')) {
      this.$router.push(`/presentation/${item.id}`);
    }
  }

  renewPresentation(item: PresentationTableItem){
    PresentationService.triggerUpdate(item.id).then(this.getPresentations).catch(this.showNetworkError);
  }

  deletePresentation(item: PresentationTableItem) {
    if(item.waitingRoomBrandingCount > 0){
      this.toast(this.t('presentation.cantDeleteBrandingsExist'), 'danger');
      return;
    }
    if(item.isGlobal && !this.hasPermission('CUSTOMER_PRESENTATION')) return;
    this.$bvModal
      .msgBoxConfirm(
        this.$t('modals.deletePresentation.description', {name: item.title}) as string,
        {
          okVariant: 'danger',
          okTitle: this.t('modals.deletePresentation.ok'),
          cancelTitle: this.t('common.cancel'),
          centered: true,
          title: this.t('modals.deletePresentation.title')
        }
      )
      .then(res => {
        if (!res) return;
        this.baseLoading = true;
        PresentationService
          .deletePresentation(item.id)
          .then(() => {
            this.getPresentations();
            this.toast(this.t('modals.deletePresentation.deleted'), 'success');
          })
          .catch(this.showNetworkError)
          .finally(() => this.baseLoading = false)
      })
  }

  deleteSelectedIds() {
    const items = this.items.filter(i => this.editIds.includes(i.id));

    // remove items, where branding count > 0
    const itemsWithBrandings = items.filter(i => i.waitingRoomBrandingCount > 0);
    if(itemsWithBrandings.length > 0){
      this.toast(this.t('presentation.cantDeleteBrandingsExist'), 'danger');
      return;
    }

    const globalItems = items.filter(i => i.isGlobal);
    if(!this.hasPermission('CUSTOMER_PRESENTATION') && globalItems.length > 0){
      this.toast(this.t('presentation.cantDeleteGlobalPresentations'), 'danger');
      return;
    }

    this.$bvModal
      .msgBoxConfirm(
        this.$t('modals.deletePresentations.description', {
          count: this.editIds.length
        }) as string,
        {
          okVariant: 'danger',
          okTitle: this.t('modals.deletePresentations.ok'),
          cancelTitle: this.t('common.cancel'),
          centered: true,
          title: this.t('modals.deletePresentations.title')
        }
      )
      .then(res => {
        if (!res) return;
        this.baseLoading = true;
        PresentationService
          .deleteSelectedPresentations(this.editIds)
          .then(() => {
            this.editIds = [];
            this.getPresentations();
            this.toast(this.t('modals.deletePresentations.deleted'), 'success');
          })
          .catch(this.showNetworkError)
          .finally(() => this.baseLoading = false)
      })
  }

  rowSelected(item: PresentationTableItem, shiftKey = false) {
    item.selected = !item.selected;
    if (item.selected) this.editIds.push(item.id);
    else this.editIds = this.editIds.filter(id => id !== item.id);
    if (shiftKey) this.selectBetween(item, item.selected);
    this.selectedEditOption = 'action';
  }

  selectAll(): void {
    this.allSelected = !this.allSelected;
    if (this.allSelected) {
      this.items.forEach(item => {
        const hasPermission = !item.isGlobal || this.hasPermission('CUSTOMER_PRESENTATION');
        if (!item.selected && hasPermission) this.rowSelected(item);
      });
    } else {
      this.items.forEach(item => {
        const hasPermission = !item.isGlobal || this.hasPermission('CUSTOMER_PRESENTATION');
        if (item.selected && hasPermission) this.rowSelected(item);
      });
    }
  }

  selectBetween(item: PresentationTableItem, value: boolean) {
    const index = this.items.findIndex(i => i.id === item.id);
    const selectedIndex = this.items.findIndex(i => i.selected === value && i.id !== item.id);
    let startIndex: number, endIndex: number;
    if (selectedIndex === -1) {
      startIndex = endIndex = index;
    } else {
      startIndex = Math.min(index, selectedIndex);
      endIndex = Math.max(index, selectedIndex);
    }
    this.items.slice(startIndex, endIndex + 1).forEach(i => {
      const hasPermission = !i.isGlobal || this.hasPermission('CUSTOMER_PRESENTATION');
      if (i.selected !== value && hasPermission) this.rowSelected(i, false);
    });
  }

  updateSelection(value: string) {
    switch (value) {
      case 'invert':
        this.items.forEach(item => {
          const hasPermission = !item.isGlobal || this.hasPermission('CUSTOMER_PRESENTATION');
          if (hasPermission) this.rowSelected(item, false);
        });
        break;
      case 'all':
        this.allSelected = false;
        this.selectAll();
        break;
      case 'none':
        this.allSelected = true;
        this.selectAll();
        break;
    }
  }

  async createNewPresentation() {
    this.baseLoading = true;
    try {
      const response = await PresentationService.createPresentation();
      const newId = response.id;
      await this.$router.push({path: `/presentation/${newId}`, query: {new: 'true'}});
    } catch (error) {
      console.error('Error creating new presentation: ', error);
    } finally {
      this.baseLoading = false;
    }
  }
}
